var map = {
	"./tcrs_en_EN/favicon.png": 55428,
	"./tcrs_en_EN/font-bold.ttf": 82553,
	"./tcrs_en_EN/font-regular.ttf": 28228,
	"./troy_de_DE/favicon.png": 64410,
	"./troy_de_DE/font-bold.woff2": 65814,
	"./troy_de_DE/font-regular.woff2": 27790,
	"./troy_nl_NL/favicon.png": 26831,
	"./troy_nl_NL/font-bold.woff2": 1735,
	"./troy_nl_NL/font-regular.woff2": 14991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48662;